import { render, staticRenderFns } from "./CompanyEditor.vue?vue&type=template&id=66648f10&scoped=true"
import script from "./CompanyEditor.vue?vue&type=script&lang=js"
export * from "./CompanyEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66648f10",
  null
  
)

export default component.exports